import React from 'react';
import Icon from '@common/components/icon';
import './export-modal.scss';
import ModalWindow from '@common/components/modal/modal-window';
import ModalContent from '@common/components/modal/modal-content';
import { useTranslation } from 'react-i18next';

type ExportModalProps = {
  show: boolean;
  onHide: () => void;
  onExportCSV: () => void;
  onExportXLS: () => void;
  onExportPDF: () => void;
};

const ExportModal: React.FC<ExportModalProps> = ({
  show,
  onHide,
  onExportCSV,
  onExportXLS,
  onExportPDF,
}) => {
  const { t } = useTranslation();
  const handleExport = (callback: () => void) => {
    callback();
    onHide();
  };

  return (
    <ModalWindow show={show} onHide={onHide} size="small">
      <ModalContent title="Export as" onHide={onHide} hideConfirm>
        <div className="tw-flex tw-flex-col tw-gap-2">
          <div
            className="tw-flex tw-flex-row tw-gap-5 tw-p-5 tw-border tw-border-solid tw-border-gray-border
          tw-rounded-lg hover:tw-bg-gray-border tw-cursor-pointer" onClick={() => handleExport(onExportCSV)}
          >
            <Icon type="csv_export" color="blue" />
            <div className="tw-text-base tw-font-semibold tw-text-gray-textDark">
              {t('performance:csv')}
            </div>
          </div>
          <div
            className="tw-flex tw-flex-row tw-gap-5 tw-p-5 tw-border tw-border-solid tw-border-gray-border
          tw-rounded-lg hover:tw-bg-gray-border tw-cursor-pointer"
            onClick={() => handleExport(onExportXLS)}
          >
            <Icon type="xls_export" color="green" />
            <div className="tw-text-base tw-font-semibold tw-text-gray-textDark">
              {t('performance:xls')}
            </div>
          </div>
          <div
            className="tw-flex tw-flex-row tw-gap-5 tw-p-5 tw-border tw-border-solid
            tw-border-gray-border tw-rounded-lg hover:tw-bg-gray-border tw-cursor-pointer"
            onClick={() => handleExport(onExportPDF)}
          >
            <Icon type="pdf_export" color="red" />
            <div className="tw-text-base tw-font-semibold tw-text-gray-textDark">
              {t('performance:pdf')}
            </div>
          </div>
        </div>
      </ModalContent>
    </ModalWindow>
  );
};

export default ExportModal;
